@if (isOpen()) {
  <div
    class="fixed inset-0 z-100 flex items-center justify-center p-4"
    role="dialog"
    aria-modal="true"
    [attr.aria-labelledby]="'confirm-dialog-title'"
  >
    <button
      type="button"
      class="absolute inset-0 bg-gray-900/60 backdrop-blur-sm cursor-default"
      aria-label="Annulla"
      (click)="cancelled.emit()"
    ></button>

    <div
      class="relative w-full max-w-2xl overflow-hidden rounded-2xl border border-gray-200 bg-white p-6 shadow-2xl dark:border-gray-700 dark:bg-gray-900"
    >
      <div class="flex items-start gap-4">
        <div
          class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-red-100 text-red-600 dark:bg-red-900/30 dark:text-red-400"
        >
          <svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
        </div>
        <div class="flex-1">
          <h3 id="confirm-dialog-title" class="text-lg font-bold text-gray-900 dark:text-white">
            {{ title() }}
          </h3>
          <p class="mt-2 text-sm text-gray-500 dark:text-gray-400">
            {{ message() }}
          </p>
        </div>
      </div>

      <div class="mt-6 flex justify-end gap-3">
        <button
          type="button"
          (click)="cancelled.emit()"
          class="h-10 cursor-pointer rounded-xl border border-gray-200 px-4 text-sm font-semibold text-gray-700 transition-colors hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800"
        >
          {{ cancelLabel() }}
        </button>
        <button
          type="button"
          (click)="confirmed.emit()"
          [disabled]="isConfirmDisabled()"
          class="h-10 cursor-pointer rounded-xl bg-red-600 px-4 text-sm font-semibold text-white shadow-lg shadow-red-500/20 transition-all hover:bg-red-700 active:scale-95 disabled:cursor-not-allowed disabled:opacity-50"
        >
          {{ confirmLabel() }}
        </button>
      </div>
    </div>
  </div>
}
